const TOGGLE_DARK_MODE = (state, value) => {
  state.darkMode = !state.darkMode;
  state.name = state.darkMode ? 'dark' : 'default';
  localStorage.setItem('darkMode', JSON.stringify(state.darkMode));
};

export default {
  TOGGLE_DARK_MODE,
};
